module.exports = __webpack_public_path__ + "static/media/Chad.8b203bc3.png";